import { Button, Modal as ModalDS } from '@iveco-ti/iveco-ds'
import { useTranslation } from 'react-i18next'

import { useModalApplication } from '../hooks/useModalApplication'

export function ModalApplication() {
  const { t } = useTranslation('common')
  const {
    title,
    description,
    cancelText,
    confirmText,
    isLoading,
    onCancel,
    onConfirm,
    resetModal,
    showButtons = true,
    disabled = false,
  } = useModalApplication()

  const handleCancel = async () => {
    if (onCancel) {
      onCancel()
    } else {
      resetModal()
    }
  }

  const handleConfirm = async () => {
    if (onConfirm) await onConfirm()
  }

  return (
    <ModalDS.Root clickOutside id="app-modal" size="xl">
      <ModalDS.Header>
        <h1 className="text-3xl font-semibold text-base-800">{title}</h1>
      </ModalDS.Header>

      <ModalDS.Body className="w-full min-h-[450px] flex h-full justify-center items-center">
        {description}
      </ModalDS.Body>

      <ModalDS.Footer>
        <div className="w-full flex items-center justify-center my-3 gap-4">
          {showButtons && (
            <>
              {cancelText && (
                <Button.Root variant="secondary" onClick={handleCancel}>
                  {cancelText}
                </Button.Root>
              )}

              <Button.Root
                variant="primary"
                onClick={handleConfirm}
                isLoading={isLoading}
                disabled={disabled}
              >
                {confirmText || t('components.modal.confirm_button.label')}
              </Button.Root>
            </>
          )}
        </div>
      </ModalDS.Footer>
    </ModalDS.Root>
  )
}
